import AsyncStorage from '@react-native-async-storage/async-storage';

const ONBOARDING_IN_PROGRESS_KEY = 'onboarding_in_progress';

export class OnboardingStateService {
  // Account-scoped routing hint, not proof of clinical membership/completion.
  static async setAuthenticatedPending(userId: string, pending: boolean): Promise<void> {
    if (!userId) throw new Error('Onboarding identity required');
    const key = `onboarding_authenticated_pending:${userId}`;
    if (pending) await AsyncStorage.setItem(key, 'true');
    else await AsyncStorage.removeItem(key);
  }

  static async isAuthenticatedPending(userId: string): Promise<boolean> {
    return await AsyncStorage.getItem(`onboarding_authenticated_pending:${userId}`) === 'true';
  }

  static async setOnboardingInProgress(inProgress: boolean): Promise<void> {
    try {
      if (inProgress) {
        await AsyncStorage.setItem(ONBOARDING_IN_PROGRESS_KEY, 'true');
        console.log('✅ Onboarding in progress flag SET');
      } else {
        await AsyncStorage.removeItem(ONBOARDING_IN_PROGRESS_KEY);
        console.log('✅ Onboarding in progress flag CLEARED');
      }
    } catch (error) {
      console.error('❌ Error setting onboarding progress flag:', error);
    }
  }

  static async isOnboardingInProgress(): Promise<boolean> {
    try {
      const value = await AsyncStorage.getItem(ONBOARDING_IN_PROGRESS_KEY);
      const inProgress = value === 'true';
      console.log(`🔍 Onboarding in progress check: ${inProgress}`);
      return inProgress;
    } catch (error) {
      console.error('❌ Error checking onboarding progress:', error);
      return false;
    }
  }

  static async clearOnboardingState(): Promise<void> {
    try {
      await AsyncStorage.removeItem(ONBOARDING_IN_PROGRESS_KEY);
      console.log('✅ Onboarding state cleared');
    } catch (error) {
      console.error('❌ Error clearing onboarding state:', error);
    }
  }
}
